var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconOpen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/Open"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M4.66661 3C4.0223 3 3.49997 3.52233 3.49997 4.16667V11.8333C3.49997 12.4777 4.0223 13 4.66661 13H12.3331C12.9774 13 13.4997 12.4777 13.4997 11.8333V9.16667C13.4997 8.89052 13.7236 8.66667 13.9997 8.66667C14.2758 8.66667 14.4997 8.89052 14.4997 9.16667V11.8333C14.4997 13.03 13.5297 14 12.3331 14H4.66661C3.47003 14 2.5 13.03 2.5 11.8333V4.16667C2.5 2.97005 3.47003 2 4.66661 2H7.33321C7.60935 2 7.8332 2.22386 7.8332 2.5C7.8332 2.77614 7.60935 3 7.33321 3H4.66661ZM9.1665 2.5C9.1665 2.22386 9.39035 2 9.66649 2H14C14.2761 2 14.5 2.22386 14.5 2.5V6.83333C14.5 7.10948 14.2761 7.33333 14 7.33333C13.7239 7.33333 13.5 7.10948 13.5 6.83333V3.70716L10.02 7.1869C9.82475 7.38216 9.50817 7.38214 9.31292 7.18687C9.11768 6.9916 9.11769 6.67501 9.31296 6.47976L12.793 3H9.66649C9.39035 3 9.1665 2.77614 9.1665 2.5Z",
    fill: "#222729"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOpen);
export default __webpack_public_path__ + "static/media/icon-open.1bed38ea32435df81d83b785399d5069.svg";
export { ForwardRef as ReactComponent };